import React from 'react';

import OrderDetailRow from '../Row';
import SkeletonItem from '../../SkeletonItem';
import { Button } from '@ets-global/b2c-website-ui';
import { useRouter } from '../../../hooks';

import './styles.scss';

const OrderDetailSkeleton = () => {
  const { lang } = useRouter();

  return (
    <div className={'order-table'}>
      <OrderDetailRow locale={lang} />
      <div className="order-table-row">
        <div className="order-table-row__col">
          <SkeletonItem style={{ height: '25px', width: '70%' }} />
        </div>
        <div className="order-table-row__col">
          <SkeletonItem style={{ height: '20px', width: '40px' }} />
        </div>
        <div className="order-table-row__col" />
        <div className="order-table-row__col">
          <SkeletonItem style={{ height: '20px', width: '40px' }} />
        </div>
      </div>
      <div className={'order-table__promo-form'} style={{ height: '89px' }}>
        <Button className={'button--full-width skeleton-item'}>
          <div style={{ width: '29px', height: '15px' }} />
        </Button>
      </div>

      <SkeletonItem className={'skeleton-item--blue order-table__total'} style={{ height: '150px', width: '100%' }} />
    </div>
  );
};

export default OrderDetailSkeleton;
